<template>
  <div class="hello">
  	<!--<headTop></headTop>-->
     <!--<courseList></courseList>-->
     <!--<land></land>-->
     <!--<CourseDetails></CourseDetails>-->
     <!--<order></order>-->
     <!--<PaymentOrder></PaymentOrder>-->
     <!--<audit></audit>-->
     <!--<orderDetail></orderDetail>-->
     <!--<orderList></orderList>-->
     <!--<ddd></ddd>-->
     <!--<Bottom></Bottom>-->
     <Home></Home>
  </div>
</template>

<script>
	import Home from "./Home/Home"
//	import headTop from "./headTop/headTop"
//import Bottom from "./Bottom/Bottom"
//import courseList from './courseList/courseList'
//import land from './land/land'
//import order from './order/order'
//import CourseDetails from "./CourseDetails/CourseDetails"
//import PaymentOrder from "./PaymentOrder/PaymentOrder"
//import audit from "./audit/audit"
//import orderDetail from "./orderDetail/orderDetail"
//import orderList from "./orderList/orderList"
//import ddd from "./ddd"
export default {
  name: 'hello',
  data () {
    return {
      token:localStorage.getItem("token")
    }
  },
  beforeCreate(){
			
  },
//components:{courseList,order,land,CourseDetails,audit,orderDetail,orderList,headTop,PaymentTop}
components:{Home}
//components:{ddd}
}
</script>
<style >
		
</style>



// WEBPACK FOOTER //
// Hello.vue?67cf79f8